package com.eladfinish.bible.contest.screens.names.utils

import com.eladfinish.bible.contest.screens.names.data.LinkInfo

actual class LinkInfoProvider {
    actual fun getLinkInfos(
        text: String,
    ): List<LinkInfo> = findWebUrlLinks(text)
}
